export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="inicio" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=modern%20luxury%20professional%20plumbing%20service%20workspace%20with%20elegant%20copper%20pipes%20premium%20tools%20sophisticated%20clean%20minimalist%20environment%20high-end%20commercial%20photography%20dramatic%20lighting%20professional%20atmosphere%20sleek%20design%20contemporary%20style&width=1920&height=1080&seq=hero-bg-ultra-pro-001&orientation=landscape"
          alt="Background"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/70 to-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 py-20 sm:py-32 w-full">
        <div className="grid lg:grid-cols-2 gap-8 sm:gap-12 items-center">
          {/* Left Column - Main Content */}
          <div className="max-w-3xl">
            {/* Premium Badge */}
            <div className="inline-flex items-center gap-2 sm:gap-3 px-4 sm:px-6 py-2 sm:py-3 rounded-full bg-white/10 backdrop-blur-md border border-white/20 mb-6 sm:mb-8">
              <div className="w-2 h-2 bg-[#3B82F6] rounded-full animate-pulse"></div>
              <span className="text-white text-xs sm:text-sm font-semibold tracking-wide">SERVICIO PREMIUM 24 HORAS</span>
            </div>

            {/* Main Title */}
            <h1 className="text-4xl sm:text-5xl lg:text-7xl font-bold text-white leading-tight mb-4 sm:mb-6">
              Calidad y exelencia en
              <span className="block text-transparent bg-clip-text bg-gradient-to-r from-[#3B82F6] via-[#60A5FA] to-[#93C5FD] mt-2">
                Fontanería
              </span>
            </h1>

            {/* Location Subtitle */}
            <p className="text-lg sm:text-xl lg:text-2xl text-white font-semibold mb-3 sm:mb-4">
              Servicio de fontanería 24 horas en Valladolid y alrededores
            </p>

            {/* Subtitle */}
            <p className="text-base sm:text-lg lg:text-xl text-gray-200 mb-8 sm:mb-10 leading-relaxed max-w-2xl">
              Soluciones profesionales de alta gama para proyectos residenciales y comerciales. Tecnología avanzada, resultados garantizados.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row flex-wrap gap-3 sm:gap-4 mb-12 sm:mb-16">
              <button
                onClick={() => scrollToSection('contacto')}
                className="bg-gradient-to-r from-[#3B82F6] to-[#2563EB] text-white px-8 sm:px-10 py-4 sm:py-5 rounded-full text-sm sm:text-base font-bold hover:shadow-2xl hover:shadow-[#3B82F6]/50 transition-all flex items-center justify-center gap-3 whitespace-nowrap cursor-pointer"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-line"></i>
                </div>
                Solicitar Servicio
              </button>
              <button
                onClick={() => scrollToSection('servicios')}
                className="bg-white/10 backdrop-blur-md border-2 border-white/30 text-white px-8 sm:px-10 py-4 sm:py-5 rounded-full text-sm sm:text-base font-bold hover:bg-white/20 transition-all flex items-center justify-center gap-3 whitespace-nowrap cursor-pointer"
              >
                Ver Servicios
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </div>
              </button>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-4 sm:gap-8">
              <div className="border-l-4 border-[#3B82F6] pl-3 sm:pl-6">
                <div className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-1 sm:mb-2">25+</div>
                <div className="text-xs sm:text-sm text-gray-300 uppercase tracking-wide">Años de Experiencia</div>
              </div>
              <div className="border-l-4 border-[#3B82F6] pl-3 sm:pl-6">
                <div className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-1 sm:mb-2">500+</div>
                <div className="text-xs sm:text-sm text-gray-300 uppercase tracking-wide">Proyectos Completados</div>
              </div>
              <div className="border-l-4 border-[#3B82F6] pl-3 sm:pl-6">
                <div className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-1 sm:mb-2">100%</div>
                <div className="text-xs sm:text-sm text-gray-300 uppercase tracking-wide">Satisfacción Garantizada</div>
              </div>
            </div>
          </div>

          {/* Right Column - Info Card (Desktop and Mobile) */}
          <div>
            <div className="space-y-4 sm:space-y-6">
              <h2 className="text-2xl sm:text-3xl font-bold text-white mb-4 sm:mb-6">
                ¡Tu fontanero de confianza en Valladolid!
              </h2>
              <div className="space-y-3 sm:space-y-4 text-gray-200 leading-relaxed">
                <p className="text-sm sm:text-base lg:text-lg leading-relaxed mb-4 sm:mb-6">
                  En FONTANERIA EL RAPIDO ofrecemos servicios de fontanería profesional para hogares y negocios. Reparaciones de fugas de agua, detección de fugas de agua, desatascos de tuberías, instalación y mantenimiento de calefacción, cambio de grifos y sanitarios, y montaje de sistemas de agua caliente.
                </p>
                <p className="text-sm sm:text-base">
                  Nuestro equipo de fontaneros expertos garantiza soluciones rápidas, seguras y efectivas, utilizando materiales de calidad y técnicas modernas. Confía en nosotros para mantener tu hogar o negocio libre de problemas de agua y fontanería.
                </p>
                <div className="pt-4 sm:pt-6 border-t border-white/20">
                  <div className="flex items-center gap-3 sm:gap-4">
                    <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-xl bg-gradient-to-br from-[#FFD700] to-[#FFA500] flex items-center justify-center flex-shrink-0">
                      <div className="w-6 h-6 sm:w-7 sm:h-7 flex items-center justify-center">
                        <i className="ri-phone-fill text-white text-xl sm:text-2xl"></i>
                      </div>
                    </div>
                    <div>
                      <div className="text-xs sm:text-sm text-gray-300 mb-1">📞 ¡Llama ahora y recibe atención inmediata!</div>
                      <a href="tel:+34640920362" className="text-xl sm:text-2xl font-bold text-[#FFD700] hover:text-[#FFA500] transition-colors cursor-pointer">
                        640 920 362
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-white/50 rounded-full"></div>
        </div>
      </div>
    </section>
  );
}
